"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const PulseLoader_1 = __importDefault(require("react-spinners/PulseLoader"));
const StyledLoader = (0, styled_1.default)(PulseLoader_1.default)({
    span: {
        fontSize: 'inherit'
    },
    fontSize: 'inherit',
    margin: '0.25em 0'
});
exports.default = StyledLoader;
//# sourceMappingURL=StyledLoader.js.map